import { DeliveryStore } from '../delivery-store';
import { IDeliveryStoreEditProps } from './delivery-store-edit.models';

export const DeliveryStoreEdit = ({ storeData, withBorder = true }: IDeliveryStoreEditProps): JSX.Element => (
  <DeliveryStore
    storeData={storeData}
    withBorder={withBorder}
  />
);
